import { clamp, findIndex, identity } from "lodash";

export function moveItemUp<T>(xs: T[], x: T): T[] {
  const index = xs.indexOf(x);
  if (index < 1) {
    return xs;
  }
  return [
    ...xs.slice(0, index - 1), //
    x,
    xs[index - 1],
    ...xs.slice(index + 1),
  ];
}

export function moveItemDown<T>(xs: T[], x: T): T[] {
  const index = xs.indexOf(x);
  if (index < 0 || index === xs.length - 1) {
    return xs;
  }
  return [
    ...xs.slice(0, index), //
    xs[index + 1],
    x,
    ...xs.slice(index + 2),
  ];
}

export function move<T>(xs: T[], x: T, toIndex: number): T[] {
  const result = xs.filter((y) => x !== y);
  if (result.length === xs.length) {
    return xs;
  }
  result.splice(clamp(toIndex, 0, xs.length - 1), 0, x);
  return result;
}

export const single = <T>(xs: T[]): T | undefined => (xs.length === 1 ? xs[0] : undefined);

export const next = <T>(
  xs: T[],
  predicate: Parameters<typeof findIndex<T>>[1] = identity,
): T | undefined => {
  return xs[findIndex(xs, predicate) + 1];
};

export const prev = <T>(
  xs: T[],
  predicate: Parameters<typeof findIndex<T>>[1] = identity,
): T | undefined => {
  return xs[findIndex(xs, predicate) - 1];
};

export const toggleElement = <T>(array: T[], element: T): T[] =>
  array.includes(element) ? array.filter((e) => e !== element) : array.concat(element);
